import { useMemo } from 'react';
import { getDashletConstraints } from '../dimensions';
import type { PluginBlockEntry } from 'ts-components/Plugins/types';
import type { PluginConstraints } from './dashletTypes';

// Stable lookup key shared between the map builder and useDashboardInteraction.
export const pluginConstraintKey = (
  pluginApiName: string,
  blockApiName: string
) => `${pluginApiName}.${blockApiName}`;

// Map of "pluginApiName.blockApiName" → resize constraints derived from the
// block definition. Constraints are never stored in dashlet payloads.
export type PluginConstraintsMap = Record<string, PluginConstraints>;

const pluginDefaults = getDashletConstraints({ area: 'plugin' }) as PluginConstraints;

export const usePluginConstraintsMap = (
  pluginBlocks: PluginBlockEntry[]
): PluginConstraintsMap => {
  return useMemo(() => {
    const map: PluginConstraintsMap = {};
    for (const pluginEntry of pluginBlocks ?? []) {
      for (const block of pluginEntry.blocks ?? []) {
        map[pluginConstraintKey(pluginEntry.plugin_api_name, block.api_name)] =
          {
            minW: block.min_w ?? pluginDefaults.minW,
            maxW: block.max_w ?? pluginDefaults.maxW,
            minH: block.min_h ?? pluginDefaults.minH,
            maxH: block.max_h ?? pluginDefaults.maxH,
          };
      }
    }
    return map;
  }, [pluginBlocks]);
};
